import { tw } from "../../styling";

type Props = {
	children: React.ReactNode;
	stepIndex: number;
};

const classes = tw`
  border-interactive-primary
  tablet:pl-4
  flex
  flex-col
  gap-2
  border-l-2
  border-dotted
  pl-0
  last:border-none
  [&>section]:mb-8
  [&>section]:border-b-2
  [&>section]:last:border-b-0
`;

const QuestionStep = ({ children, stepIndex }: Props) => (
	<section className={classes} id={`question-set-${stepIndex}`}>
		{children}
	</section>
);

export default QuestionStep;
